import { createSlice } from "@reduxjs/toolkit";

interface PushTokenState {
  token: string | null;
}

const initialState: PushTokenState = {
  token: null,
};

export const pushTokenSlice = createSlice({
  name: "pushToken",
  initialState,
  reducers: {
    setPushToken: (state, { payload }) => {
      state.token = payload;
    },

    removePushToken: (state) => {
      state.token = null;
    },
  },
});

export const { setPushToken, removePushToken } = pushTokenSlice.actions;
export default pushTokenSlice.reducer;
